let mixinList = {
  data () {
    return {
      p: 1, // 页码
      l: 20, // 每页数
      total: 0, // 总数
      list: [] // 列表
    }
  },
  methods: {
    // 获取列表，需重写
    getList () {

    },
    // 搜索
    search () {
      this.p = 1
      this.getList()
    },
    // 改变每页数
    handleSizeChange (val) {
      this.l = val
      this.getList()
    },
    // 改变页码
    handleCurrentChange (val) {
      this.p = val
      this.getList()
    }
  }
}
export default mixinList



// WEBPACK FOOTER //
// ./src/mixins/list.js